module.exports = require("css.escape");


//////////////////
// WEBPACK FOOTER
// external "css.escape"
// module id = 483
// module chunks = 0